/* ROUTES  */
export const ROUTES = {
  MAIN: '/',
  SIGNOUT: '/signout',
  REGISTER: '/register',
  VERIFY_OTP: '/verify-otp',
  LOGIN: '/login',
  VERIFY: '/verify',
  AUTHENTICATION: '/authentication',
  PROFILE: '/profile',
  UPLOAD_FLOOR_PLAN: '/upload-floor-plan',
  CHOOSE_DIRECTION: '/choose-direction',
  CHOOSE_ENTRANCE: '/choose-entrance',
  ANNOTATION_INFO: '/annotation-info',
  VASTU_RULE: '/vastu-rule',
  VASTU_ANNOTATION: '/annotation/:id',
  VASTU_REPORT: '/report/:id',
};

export const DIRECTIONS = [
  { angle: 0, label: 'North' },
  { angle: 22.5, label: 'North-North-East (NNE)' },
  { angle: 45, label: 'North-East (NE)' },
  { angle: 67.5, label: 'East-North-East (ENE)' },
  { angle: 90, label: 'East' },
  { angle: 112.5, label: 'East-South-East (ESE)' },
  { angle: 135, label: 'South-East (SE)' },
  { angle: 157.5, label: 'South-South-East (SSE)' },
  { angle: 180, label: 'South' },
  { angle: 202.5, label: 'South-South-West (SSW)' },
  { angle: 225, label: 'South-West (SW)' },
  { angle: 247.5, label: 'West-South-West (WSW)' },
  { angle: 270, label: 'West' },
  { angle: 292.5, label: 'West-North-West (WNW)' },
  { angle: 315, label: 'North-West (NW)' },
  { angle: 337.5, label: 'North-North-West (NNW)' },
];

export const LOCAL_STORAGE = {
  TOUR_GUIDE: 'TOUR_GUIDE',
  UPLOAD_FLOOR_PLAN_SEQUENCE: 'UPLOAD_FLOOR_PLAN_SEQUENCE',
  FLOOR_PLAN: 'FLOOR_PLAN',
  TOKEN: 'TOKEN',
  REFRESH_TOKEN: 'REFRESH_TOKEN',
  USER: 'USER',
  OTP_LESS_TOKEN: 'OTP_LESS_TOKEN',
  OTP_TIMER: 'OTP_TIMER',
  OTP_START_TIME: 'OTP_START_TIME',
  OTP_ATTEMPTS: 'OTP_ATTEMPTS',
  LAST_PHONE_NUMBER: 'LAST_PHONE_NUMBER',
  OTP_BLOCK_TIME: 'OTP_BLOCK_TIME',
  OTP_STEP: 'OTP_STEP',
  CURRENT_PHONE: 'CURRENT_PHONE',
};

export const TIMER = {
  INITIAL_TIME_SECONDS: 29,
  SECOND_TIME_RESEND_OTP_SECONDS: 59,
  THIRD_TIME_RESEND_OTP_SECONDS: 89,
  MAX_OTP_ATTEMPTS: 2,
  BLOCK_DURATION_SECONDS: 599,
};

export const BROWSER_TYPES = {
  WINDOWS: { key: 'Win', value: 'Windows' },
  MAC: { key: 'Mac', value: 'Mac OS' },
  LINUX: { key: 'Linux', value: 'Linux' },
};

/*  Modules */
export const MODULES = {
  DASHBOARD: 'Dashboard',
};

export const Level = {
  High: 'high',
  Medium: 'medium',
  Low: 'low',
};

export const DEFAULT_COLORS = {
  severity: {
    [Level.High]: '#A72222',
    [Level.Medium]: '#9D6300',
    [Level.Low]: '#0047B3',
  },
  confidence: {
    [Level.High]: '#0C7A18',
    [Level.Medium]: '#9D6300',
    [Level.Low]: '#A72222',
  },
};

export const AREA_TYPES = {
  BED: 'bed',
  BATHROOM: 'bathroom',
  LIVING_ROOM: 'living room',
  TOILET_SEAT: 'toilet seat',
  ENTRANCE: 'entrance',
  KITCHEN: 'kitchen',
};

export const AREA_PARENT_TYPE = {
  BOTH: 'both',
  PARENT: 'parent',
};

export const LIMIT = 10;

export const DATEFORMAT = 'DD/MM/YYYY';

export const ERROR_PAGE_TITLE = 'Oops! An error occurred!';
export const ERROR_PAGE_SUBTITLE =
  'Something is broken. Please let us know what you were doing when this error occurred. We will fix it as soon as possible. Sorry for any inconvenience caused.';

export const REGEX = {
  NAME: /^(?! *$)[A-Za-z ]+$/,
  ZIPCODE: /^[0-9]{5,6}$/,
  CITY: /^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/,
  WEB_URL:
    /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi,
  PASSWORD: /^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9!@#$%^&*]{8,16}$/,
  PHONE: /^\+?[1-9]\d{1,3}[-\s]?\d{6,14}$/,
  EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  AMOUNT: /^\d+$|^\d+\.\d*$/,
  OPTIONALNEGATIVEAMOUNT: /^[-]?\d+$|^[-]?\d+\.\d*$/,
  NUMBER: /^\d{4,6}$/,
  COUNTRY_CODE_PHONE: /^[0-9]{7,12}$/,
};

export const BREAKPOINTS = {
  mobile: 550,
  tablet: 767,
  desktop: 1000,
  hd: 1200,
};

export const GUTTER_VARIATIONS = { xs: 16, sm: 16, md: 24, lg: 32 };

export const COMPANY_INFO = { COOKIE_EXPIRY: 259200 };

export const MOBILE_SIZE = 767;
export const TABLET_SIZE = 991;

export const BREAK_POINTS = {
  screen320: 320,
  screen375: 375,
  screen425: 425,
  screen540: 540,
  screen767: 767,
  screen991: 991,
  screen1024: 1024,
  screen1150: 1150,
  screen1450: 1450,
};

export const ALL_IMAGE_UPLOAD = ['jpeg', 'jpg', 'png'];
